export default function formatarEmMoeda(valor, moeda) {
  if (!valor) {
    return 'N/I';
  }

  if (typeof valor === 'string') {
    valor = parseFloat(valor.replace(',', '.'));
  }

  if (Number.isNaN(valor)) {
    return 'Valor inválido';
  }

  return valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: moeda,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
